/* ==========================================================================
   Marmotech — header behaviour
   1. Mobile nav toggle (designed addition; the source has no mobile layout)
   2. Keeps the cart badge in sync after add-to-cart
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 989px)');
  var nav = document.getElementById('mt-header-nav');
  var toggle = document.querySelector('[data-mt-nav-toggle]');

  /* ---------- mobile nav ---------- */
  function close() {
    if (!nav || !toggle) return;
    nav.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  }

  function open() {
    if (!nav || !toggle) return;
    nav.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
  }

  // The nav is a plain flex row on desktop, so the `hidden` attribute must be
  // removed entirely above the breakpoint rather than just overridden in CSS —
  // otherwise assistive tech skips the whole menu.
  function syncToViewport() {
    if (!nav) return;
    if (MOBILE.matches) {
      close();
    } else {
      nav.hidden = false;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        close();
      } else {
        open();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        close();
        toggle.focus();
      }
    });

    // Close after following a link on mobile (same-page anchors especially).
    nav.addEventListener('click', function (event) {
      if (MOBILE.matches && event.target.closest('a')) close();
    });
  }

  if (MOBILE.addEventListener) {
    MOBILE.addEventListener('change', syncToViewport);
  } else if (MOBILE.addListener) {
    MOBILE.addListener(syncToViewport);
  }
  syncToViewport();

  /* ---------- cart badge ---------- */
  function paintCount(count) {
    var badges = document.querySelectorAll('[data-mt-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].hidden = count === 0;
      var link = badges[i].closest('a');
      if (link) {
        link.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
      }
    }
  }

  function refreshCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) paintCount(cart.item_count);
      })
      .catch(function () {
        /* Badge keeps its server-rendered value — nothing to recover. */
      });
  }

  // Dawn broadcasts cart changes through its own pub/sub rather than DOM events.
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCount);
  }
  document.addEventListener('cart:refresh', refreshCount);

  // mt-cart.js already knows the new count from the re-rendered drawer, so it
  // pushes the number here rather than making everyone re-fetch /cart.js.
  document.addEventListener('cart:count', function (event) {
    if (event.detail && typeof event.detail.count === 'number') paintCount(event.detail.count);
  });

  // Back/forward cache can restore a stale badge.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCount();
  });
})();
